import { render, staticRenderFns } from "./MaterialSelect.vue?vue&type=template&id=a3245a3a&scoped=true&"
import script from "./MaterialSelect.vue?vue&type=script&lang=js&"
export * from "./MaterialSelect.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSelect.vue?vue&type=style&index=0&id=a3245a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3245a3a",
  null
  
)

export default component.exports